<template>
  <ion-page>
    <Background></Background>
    <WhiteBackground></WhiteBackground>

    <ion-content>
      <div class="flow-content">
        <TestFinishTips class="finishTips"></TestFinishTips>
        <TestConfirmTips text="請按「確定」查看測試結果" class="confirmTips"></TestConfirmTips>
        <ConfirmButton class="finish-confirm-button" position="relative" @click="goTestResult"></ConfirmButton>
        <TestNumber :number="user_info.number"></TestNumber>
      </div>
    </ion-content>
  </ion-page>

</template>

<script>
import TestFinishTips from "../components/test/TestFinishTips";
import {IonContent, IonPage} from "@ionic/vue";
import Background from "../components/common/Background";
import TestNumber from "../components/test/TestNumber";
import TestConfirmTips from "../components/test/TestConfirmTips";
import ConfirmButton from "../components/common/ConfirmButton";
import WhiteBackground from "../components/common/WhiteBackground";
import router from "../router";
import common from "../common";

export default {
  name: "TestFinish",
  components: {
    WhiteBackground,
    ConfirmButton,
    TestConfirmTips,
    TestNumber,
    Background,
    TestFinishTips,
    IonPage,
    IonContent
  },
  data() {
    return {
      user_info: {},
      audio: null,
      play_timeout: null,
    }
  },
  ionViewWillEnter() {
    common.getUserInfo().then(user_info => {
      this.user_info = user_info;
    })

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    this.play_timeout = setTimeout(function () {
      that.audio = new Audio(common.getVoice(14));
      that.audio.play();
    }, 2000);

  },
  ionViewWillLeave(){
    if (this.audio) {
      this.audio.pause();
    }
    if (this.play_timeout) {
      clearTimeout(this.play_timeout)
    }
  },
  methods: {
    goTestResult: function () {
      router.replace('/testResult');
    }
  }
}
</script>

<style scoped>
  .finishTips{
    margin-top: clamp(1rem, 12vh, 10rem);
  }

  .finish-confirm-button :deep(.relative) {
    margin: clamp(0.75rem, 2vw, 1.25rem) auto 0;
  }
</style>
